import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import moment from "moment-timezone";
import {
  addNewFactor,
  getCurrentCollection,
  getPresetsDropdown,
} from "src/actions/prioritize";
import {
  PrioritizeCreateModal,
  DialogModalWindow,
  Button,
  Modal,
  NewPreset,
} from "src/components/shared";
import TemplateBrowser from "src/components/TemplateBrowser/TemplateBrowser";
import FactorGrid from "src/components/Factor/FactorGrid.tsx";
import collectionApi from "src/api/v2/CollectionApi";
import Logger from "src/util/Logger";
import { LABELS, DEFAULT_SUB_COLLECTIONS } from "src/util/PrioritizeUtil";
import Create from "./";
import Header, { Subtitle } from "../Header";
// import Footer from 'src/pages/Prioritize/Create/Footer'
import { GLOBAL_PATH_PREFIX } from "src/constants";
import { models } from "src/components/Factor";

const FACTORS_SOURCE = models.FactorsSource.CURRENT;

class ManageFactors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPresetKey: props.selectedPreset,
      newPresetName: "",
      isNewPresetModalOpen: false,
      unsavedFactors: [],
      unsavedAlert: false,
      isTemplateModalOpen: false,
    };
  }

  initializeState = async () => {
    const presets = await collectionApi.getAllByType("prioritize-factors");
    this.props.getPresetsDropdown(presets);
    this.setState({
      selectedPreset: presets.find((preset) => preset.public),
    });

    const { pathname } = this.props.location;
    const pathArray = pathname.split("/");
    // Edit mode
    if (pathArray && pathArray.length >= 5 && pathArray[4] === "edit") {
      if (pathArray[5] === "factors") {
        this.setState({ step: 2 });
      }
      const id = pathArray[3];

      const collectionDetails = await collectionApi.get({ id });
      this.props.getCurrentCollection(collectionDetails);

      const selectedPreset = presets.find(
        ({ collection_sub_type }) =>
          collection_sub_type === collectionDetails.collection_sub_type
      );

      this.setState({
        id: collectionDetails.id,
        items: collectionDetails.children || DEFAULT_SUB_COLLECTIONS,
        selectedPreset: selectedPreset,
        title: collectionDetails.title,
        endDatetime: moment(collectionDetails.end_on),
        customAttr1: collectionDetails.custom_attr_1,
      });
    }
  };

  componentDidMount = () => {
    this.initializeState();
  };

  componentDidUpdate = () => {
    const { currentPresetKey, newlyCreatedPresetKey } = this.state;

    const { selectedPreset, presets } = this.props;

    if (selectedPreset && !currentPresetKey)
      this.setState({ currentPresetKey: selectedPreset });

    if (
      newlyCreatedPresetKey &&
      presets.find(
        ({ collection_sub_type }) =>
          newlyCreatedPresetKey === collection_sub_type
      )
    ) {
      this.setState({ currentPresetKey: newlyCreatedPresetKey });
      delete this.state.newlyCreatedPresetKey;
    }
  };

  onConfirmUnsavedFactors = () => {
    this.setState({ unsavedAlert: false, unsavedFactors: [] });
    this.onSaveNPreview();
  };

  onBack = () => {
    const { location, history } = this.props;
    if (location.pathname.match(/p\/.*\/edit\/factors/)) {
      this.setState({ step: this.state.step - 1 });
      const editUrl = location.pathname.split("/");
      editUrl.pop();
      history.push(`${editUrl.join("/")}`);
    } else {
      window.location.href = "/#/dashboard";
    }
  };

  onConfirmChangePreset = async () => {
    const { potentialPresetKey } = this.state;
    if (!potentialPresetKey) return;

    this.setState({
      currentPresetKey: potentialPresetKey,
    });

    delete this.state.potentialPresetKey;

    // remove existing factors (questions)
    await collectionApi.deleteQuestions(this.props.collection.id);

    // get selected preset factors
    const presetFactors = await this.getSelectedPresetFactors(
      potentialPresetKey
    );

    // copy selected factors (or create new questions on the root collection)
    const newFactors = await collectionApi.createQuestions(
      this.props.collection.id,
      presetFactors
    );

    // update collection redux state with new factors
    this.props.collection.questions = newFactors;
    this.props.getCurrentCollection(this.props.collection);
  };

  // FACTORS
  getSelectedPresetFactors = async (selectedPreset) => {
    const { currentFactors } = this.props;

    const collection = this.props.presets.find(
      ({ collection_sub_type }) => selectedPreset === collection_sub_type
    );
    if (!collection) return currentFactors;

    const newFactors = await collectionApi.getQuestionsByCollectionId(
      collection.id
    );
    if (!newFactors) return currentFactors;
    return newFactors;
  };

  onSaveNPreview = () => {
    Logger.info("Save & Preview clicked");
    if (this.state.unsavedFactors.length) {
      this.setState({ unsavedAlert: true });
      return;
    }
    const participateURI = `${GLOBAL_PATH_PREFIX}/p/${this.props.collection.id}`;
    this.props.history.push(participateURI);
  };

  onButtonClick = (buttonType) => () => {
    const { items } = this.state;

    switch (buttonType) {
      case "back":
        this.onBack();
        break;
      case "add":
        this.onStateChange("items", [
          ...items,
          { title: "", custom_attr_1: "" },
        ]);
        break;
      case "save_preset":
        this.setState({ isNewPresetModalOpen: true });
        break;
      case "submit":
        this.onSaveNPreview();
        break;

      default:
        break;
    }
  };

  render() {
    const { unsavedAlert, isTemplateModalOpen, templatePreset } = this.state;

    const step = 2;

    const UNSAVED_FACTORS = `You have some factors that wasn't saved after editing`;

    const style = { padding: 0, height: '75vh' };

    return (
      <Create onNavClick={this.onButtonClick} step={step}>
        <Header hasNav>
          <div className="prioritize__header-title">
            <Subtitle text={`Step ${step} of 2`} />
            <h1>{LABELS.create_steps_title[step - 1]}</h1>
          </div>

          <div className="prioritize__header-nav">
            <Button lg flat cancel onClick={this.onBack}>
              Back
            </Button>
            <Button lg primary submit onClick={this.onSaveNPreview}>
              Save &amp; Preview
            </Button>
          </div>
        </Header>

        <div className="create-step2__preset_subtitles">
          {templatePreset && (
            <div className="preset_name">{templatePreset?.title}</div>
          )}
          <Button
            lg
            flat
            submit
            onClick={() => this.setState({ isTemplateModalOpen: true })}
          >
            Browse Templates
          </Button>
          <NewPreset
            factorsSource={FACTORS_SOURCE}
            setCurrentPreset={(selectedPreset) =>
              this.setState({ selectedPreset })
            }
          />
        </div>

        <div className="create-step2">
          <FactorGrid source={FACTORS_SOURCE} />
        </div>

        {/* MODALS */}
        <PrioritizeCreateModal isOpen={false} />

        <DialogModalWindow
          isOpen={unsavedAlert}
          title={UNSAVED_FACTORS}
          onCancel={this.onCancelUnsavedFactors}
          onConfirm={this.onConfirmUnsavedFactors}
          confirmBtnText="Continue"
        />
        {isTemplateModalOpen && (
          <Modal
            isOpen={isTemplateModalOpen}
            withCross={false}
            style={style}
            className="container"
          >
            <TemplateBrowser
              setPreset={(templatePreset) => this.setState({ templatePreset })}
              onCancel={() => this.setState({ isTemplateModalOpen: false })}
              onChoose={() => this.setState({ isTemplateModalOpen: false })}
            />
          </Modal>
        )}
      </Create>
    );
  }
}

const mapStateToProps = ({ prioritize }) => {
  return {
    presets: prioritize.presets || [],
    collection: prioritize.collection,
    selectedPreset: prioritize.selectedPreset,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    addNewFactor,
    getCurrentCollection,
    getPresetsDropdown,
  })(ManageFactors)
);
